import { AdminPageLayout } from "@/features/admin/components/AdminPageLayout";
import { useNav } from "@/utils/nav";
import { ANIMATION_TYPES, AnimatedIcon, type AnimationType } from "@patient-watch/icons";
import { ui } from "@patient-watch/ui";
import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";

export const Route = createFileRoute("/_app/design/icons/animations")({
    component: AnimationIconsDemo,
});

const ANIMATIONS = [...ANIMATION_TYPES].sort((left, right) => left.localeCompare(right));

function AnimationIconsDemo() {
    useNav([
        { label: "Design", route: { to: "/design" } },
        { label: "Icons", route: { to: "/design/icons" } },
        { label: "Animations", route: { to: "/design/icons/animations" } },
    ]);

    const [hovered, setHovered] = useState<AnimationType | null>(null);

    return (
        <AdminPageLayout
            title="Animation icons"
            description="Lottie icons from @patient-watch/icons. Hover a card to play it."
            maxWidthClassName="max-w-5xl"
        >
            <div className="gap-4 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4">
                {ANIMATIONS.map((animation) => (
                    <ui.Card
                        key={animation}
                        className="hover:bg-muted/40 transition-colors"
                        onMouseEnter={() => setHovered(animation)}
                        onMouseLeave={() => setHovered((current) => (current === animation ? null : current))}
                    >
                        <ui.CardContent className="flex flex-col items-center gap-4 p-6">
                            <AnimatedIcon animation={animation} size={64} isHovered={hovered === animation} />
                            <p className="font-mono text-sm text-center">{animation}</p>
                        </ui.CardContent>
                    </ui.Card>
                ))}
            </div>
        </AdminPageLayout>
    );
}
